<div class="container-fluid parameters-page">

    <div class="parameters-card">

        <!-- ====================================================== -->
        <!-- HEADER -->
        <!-- ====================================================== -->

        <div class="parameters-header">

            <div class="parameters-header-info">

                <div class="parameters-header-icon">
                    <i class="fa-solid fa-sliders"></i>
                </div>

                <div>
                    <h5 class="parameters-title">
                        Parámetros
                    </h5>

                    <p class="parameters-description">
                        Administra los parámetros de configuración del sistema.
                    </p>
                </div>

            </div>


            <div class="parameters-header-actions">

                <button
                    type="button"
                    class="btn btn-primary btn-add"
                    (click)="openModalNewParameter()">

                    <i class="fa-solid fa-plus"></i>

                    <span>
                        Agregar parámetro
                    </span>

                </button>

            </div>

        </div>


        <!-- ====================================================== -->
        <!-- BODY -->
        <!-- ====================================================== -->

        <div class="parameters-body">


            <!-- ================================================== -->
            <!-- BUSCADOR -->
            <!-- Se conserva exactamente tu lógica *ngIf="false" -->
            <!-- ================================================== -->

            <div class="search-section" *ngIf="false">

                <div class="row">

                    <div class="col-12 col-lg-6">

                        <div class="input-group search-input">

                            <span class="input-group-text">
                                <i class="fa-solid fa-magnifying-glass"></i>
                            </span>

                            <input
                                type="text"
                                class="form-control"
                                placeholder="Buscar parámetro o etiqueta"
                                aria-label="Buscar parámetro o etiqueta"
                                aria-describedby="basic-addon2">

                            <button
                                type="button"
                                class="btn search-button"
                                id="basic-addon2">

                                <i class="fa-solid fa-magnifying-glass"></i>

                            </button>

                        </div>

                    </div>

                </div>

            </div>


            <!-- ================================================== -->
            <!-- TABLA -->
            <!-- ================================================== -->

            <div class="parameters-table">

                <app-paginacion
                    [currentPage]="currentPage"
                    [totalItems]="totalItems"
                    [selectedPageSize]="pageSize"
                    [paginatedData]="currentItems"
                    [headers]="tableHeaders"
                    [actions]="customActions"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)"
                    [loading]="spinner">
                </app-paginacion>

            </div>

        </div>

    </div>

</div>


<!-- ========================================================== -->
<!-- MODAL AGREGAR / EDITAR PARÁMETRO -->
<!-- ========================================================== -->

<ng-template #modalAgregarParametro let-modal>

    <!-- ====================================================== -->
    <!-- HEADER -->
    <!-- ====================================================== -->

    <div class="modal-header parameter-modal-header">

        <div class="modal-title-wrapper">

            <div class="modal-title-icon">
                <i
                    class="fa-solid"
                    [ngClass]="!isEdition ? 'fa-plus' : 'fa-pen'">
                </i>
            </div>


            <div class="modal-title-info">

                <h5 class="modal-title">
                    {{ !isEdition ? 'Agregar parámetro' : 'Editar parámetro' }}
                </h5>

                <p>
                    Configura la información del parámetro.
                </p>

            </div>

        </div>


        <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            (click)="modal.dismiss('Cross click')">
        </button>

    </div>


    <!-- ====================================================== -->
    <!-- BODY -->
    <!-- ====================================================== -->

    <div class="modal-body parameter-modal-body">

        <form
            [formGroup]="formParametros"
            class="parameter-form">


            <!-- ================================================== -->
            <!-- PARÁMETRO -->
            <!-- ================================================== -->

            <div class="field-group">

                <label
                    for="parametro"
                    class="form-label">

                    Parámetro

                </label>


                <div class="input-modern">

                    <i class="fa-solid fa-code"></i>

                    <input
                        id="parametro"
                        type="text"
                        class="form-control"
                        placeholder="Ej. timeout_session"
                        formControlName="parametro" />

                </div>

                <small class="field-help">
                    Nombre utilizado para identificar el parámetro.
                </small>

            </div>


            <!-- ================================================== -->
            <!-- ETIQUETA -->
            <!-- ================================================== -->

            <div class="field-group">

                <label
                    for="etiqueta"
                    class="form-label">

                    Etiqueta

                </label>


                <div class="input-modern">

                    <i class="fa-solid fa-tag"></i>

                    <input
                        id="etiqueta"
                        type="text"
                        class="form-control"
                        placeholder="Ej. Tiempo de sesión"
                        formControlName="etiqueta" />

                </div>

                <small class="field-help">
                    Nombre descriptivo que verá el usuario.
                </small>

            </div>


            <!-- ================================================== -->
            <!-- VALOR -->
            <!-- ================================================== -->

            <div class="field-group">

                <label
                    for="valorParametro"
                    class="form-label">

                    Valor del parámetro

                </label>


                <div class="input-modern">

                    <i class="fa-solid fa-keyboard"></i>

                    <input
                        id="valorParametro"
                        type="text"
                        class="form-control"
                        placeholder="Ej. 30"
                        formControlName="valorParametro" />

                </div>

                <small class="field-help">
                    Valor que será utilizado por el sistema.
                </small>

            </div>


            <!-- ================================================== -->
            <!-- DESCRIPCIÓN -->
            <!-- ================================================== -->

            <div class="field-group mb-0">

                <label
                    for="descripcion"
                    class="form-label">

                    Descripción

                </label>


                <textarea
                    id="descripcion"
                    class="form-control description-textarea"
                    rows="4"
                    placeholder="Describe para qué sirve este parámetro"
                    formControlName="descripcion">
                </textarea>

            </div>

        </form>

    </div>


    <!-- ====================================================== -->
    <!-- FOOTER -->
    <!-- ====================================================== -->

    <div class="modal-footer parameter-modal-footer">

        <button
            type="button"
            class="btn btn-light btn-modal-secondary"
            (click)="modal.close('Cerrar click')">

            Cancelar

        </button>


        <button
            type="button"
            class="btn btn-primary btn-modal-primary"
            (click)="action()">

            <i
                class="fa-solid me-2"
                [ngClass]="!isEdition ? 'fa-plus' : 'fa-check'">
            </i>

            {{ !isEdition ? 'Agregar' : 'Actualizar' }}

        </button>

    </div>

</ng-template>